import React, { useState, useEffect } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { authAPI } from '../../services/api';
import './MyQRCode.css';

const MyQRCode = () => {
  const [qrData, setQrData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [qrSize, setQrSize] = useState(260);

  useEffect(() => {
    fetchQRCode();
  }, []);

  useEffect(() => {
    const updateSize = () => {
      const width = window.innerWidth;
      if (width < 360) {
        setQrSize(Math.min(width - 80, 220));
      } else if (width < 480) {
        setQrSize(240);
      } else {
        setQrSize(280);
      }
    };

    updateSize();
    window.addEventListener('resize', updateSize);
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  const fetchQRCode = async () => {
    try {
      const response = await authAPI.getQRCode();
      if (!response.data?.qr_code_token) {
        setError('尚未建立會員 QR 碼，請聯絡管理員');
        return;
      }
      setQrData(response.data);
    } catch (err) {
      console.error('Failed to fetch QR code:', err);
      setError(err.response?.data?.error || '無法獲取 QR 碼');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading"><div className="spinner"></div></div>;
  }

  if (error || !qrData) {
    return (
      <div className="qr-code-page">
        <h1>我的QR碼</h1>
        <div className="alert alert-error">{error || '無法獲取QR碼'}</div>
      </div>
    );
  }

  return (
    <div className="qr-code-page">
      <h1>我的QR碼</h1>
      <div className="qr-card card text-center">
        <h2>{qrData.chinese_name}</h2>
        <p className="member-number">會員編號：{qrData.member_number}</p>

        <div className="qr-code-container">
          <QRCodeSVG
            value={qrData.qr_code_token}
            size={qrSize}
            level="H"
            includeMargin={true}
            className="qr-code-svg"
          />
        </div>

        <div className="qr-instructions">
          <h3>使用說明</h3>
          <ul>
            <li>核對會員身份時，請出示此QR碼給工作人員掃描</li>
            <li>請確保QR碼清晰可見</li>
            <li>此QR碼為您的唯一識別碼，請勿與他人分享</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default MyQRCode;
